import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const stateOptions = [{
  value: 'baden_wuerttemberg',
  translated: 'baden_wuerttemberg',
  label: 'Baden-Wuerttemberg'
}, {
  value: 'bayern',
  translated: 'bayern',
  label: 'Bayern'
}, {
  value: 'berlin',
  translated: 'berlin',
  label: 'Berlin'
}, {
  value: 'brandenburg',
  translated: 'brandenburg',
  label: 'Brandenburg'
}, {
  value: 'bremen',
  translated: 'bremen',
  label: 'Bremen'
}, {
  value: 'hamuburg',
  translated: 'hamburg',
  label: 'Hamburg'
}, {
  value: 'hesse',
  translated: 'hesse',
  label: 'Hesse'
}, {
  value: 'mecklenburg_vorpommern',
  translated: 'mecklenburg_vorpommern',
  label: 'Mecklenburg-Vorpommern'
}, {
  value: 'lower_saxony',
  translated: 'lower_saxony',
  label: 'Lower Saxony'
}, {
  value: 'north_rhine_westphalia',
  translated: 'north_rhine_westphalia',
  label: 'North Rhine-Westphalia'
}, {
  value: 'rheinland_pfalz',
  translated: 'rheinland_pfalz',
  label: 'Rheinland-Pfalz'
}, {
  value: 'saarland',
  translated: 'saarland',
  label: 'Saarland'
}, {
  value: 'saxony',
  translated: 'saxony',
  label: 'Saxony'
}, {
  value: 'saxony_anhalt',
  translated: 'saxony_anhalt',
  label: 'Saxony-Anhalt'
}, {
  value: 'schleswig_holstein',
  translated: 'schleswig_holstein',
  label: 'Schleswig-Holstein'
}, {
  value: 'thuringia',
  translated: 'thuringia',
  label: 'Thuringia'
}];
const StateSelect = _ref => {
  let {
    value,
    onChange,
    disabled,
    name = 'state_of_tax_office',
    className = 'col-md-4'
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Form.Group, {
    as: Col,
    className: className
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('federal_state'), "*"), /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    value: value !== null && value !== void 0 ? value : '',
    name: name,
    onChange: onChange,
    size: "md",
    disabled: disabled
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }), stateOptions.map(state => /*#__PURE__*/React.createElement("option", {
    key: state.value,
    value: state.value
  }, t(state.translated)))));
};
export default StateSelect;